import { CheckCircle2, HeartHandshake } from "lucide-react";
import MotionSection from "../common/MotionSection";
import { contactPageData } from "../../data/contactData";

function ContactReassuranceSection() {
  const { reassurance } = contactPageData;

  return (
    <MotionSection className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-6">
        <div className="grid gap-7 lg:grid-cols-[0.92fr_1.08fr] lg:items-center">
          <article className="rounded-[1.8rem] border border-midnight-navy/12 bg-gradient-to-br from-white to-sky-glow/60 p-7 shadow-soft md:p-8">
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-sky-glow text-royal-blue">
              <HeartHandshake className="h-6 w-6" aria-hidden="true" />
            </span>
            <h2 className="mt-4 text-2xl leading-tight sm:text-3xl md:text-4xl">{reassurance.title}</h2>
            <p className="mt-4 text-sm leading-relaxed text-slate-text/82 sm:text-base">
              We prioritize clarity, comfort, and informed choices so your next step feels confident from day one.
            </p>
          </article>

          <div className="space-y-3">
            {reassurance.points.map((point) => (
              <div
                key={point}
                className="flex items-start gap-3 rounded-2xl border border-midnight-navy/10 bg-white/90 px-5 py-4 shadow-soft transition duration-300 hover:border-royal-blue/25 hover:bg-sky-glow/45"
              >
                <CheckCircle2 className="mt-0.5 h-5 w-5 flex-none text-royal-blue" aria-hidden="true" />
                <p className="text-sm leading-relaxed text-slate-text/85 md:text-base">{point}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </MotionSection>
  );
}

export default ContactReassuranceSection;
